import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {FisoMathProvider} from "../../providers/fiso-math/fiso-math";
import {VideoShopPage} from "../video-shop/video-shop";
import {VideoDetailPage} from "../video-detail/video-detail";

/**
 * Generated class for the VideoListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-video-list',
    templateUrl: 'video-list.html',
    providers: [FisoMathProvider]
})
export class VideoListPage {
    isMine = false;
    items: any = [];

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public fisoMathProvider: FisoMathProvider,
                private loadingCtrl: LoadingController) {

    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad VideoListPage');
    }

    ionViewWillEnter() {
        console.log('ionViewWillEnter VideoListPage');

        const loader = this.loadingCtrl.create({
            content: "Please wait..."
        });
        loader.present();

        this.fisoMathProvider.posts({
            post_type: 'training_video',
            page: 0,
            ppp: 1000
        }).subscribe((resp: any) => {
            this.items = [...resp.data];
            loader.dismiss();
        }, err => {
            loader.dismiss();
        });
    }

    shopNow(item) {
        this.navCtrl.push(VideoShopPage, {item: item});
    }

    learNow(item) {
        this.navCtrl.push(VideoDetailPage, {item: item});
    }

}



// WEBPACK FOOTER //
// ./src/pages/video-list/video-list.ts